export const environment = {
  production: false,
  KINOMAP_API_URL: 'https://api.kinomap.dev/v4',
  KINOMAP_WEBSITE_URL: 'https://www.kinomap.dev',
  KINOMAP_ADMIN_URL: 'https://admin-beta.kinomap.dev',
  API_APP_TOKEN:
    '1cey0vihf7f5359ddfaapxxiptpmvqzq9ce12442rzvk1dolflmd7d3bn6egzeofksgh4jwd4wmmmomxcotfqovcc3qkvr342bwk4ga1v5b3ngsshrnfukyj',
};
